import { NameAndCode } from '@/fetching/sharedSchemas/basicSchemas';
import {
    QueryShiftRecurrenceArgs,
    ShiftRecurrenceFilter,
    ShiftRecurrenceOrdering,
} from 'gql-types';

import { FilterOperator } from './lists/filtering';

/**********************
 * Shift Types
 *********************/
export namespace Shift {
    export type Filters = ShiftRecurrenceFilter;
    export type Ordering = ShiftRecurrenceOrdering;
    export type ListVariables = QueryShiftRecurrenceArgs;
}

/**********************
 * Shift Enums
 *********************/
export enum ShiftType {
    CLINIC = 'CLINIC',
    MOBILE = 'MOBILE',
    VIRTUAL = 'VIRTUAL',
}

export const renderShiftType = (shiftType: ShiftType): string => {
    switch (shiftType) {
        case ShiftType.MOBILE:
            return 'Mobile';
        case ShiftType.CLINIC:
            return 'Clinic';
        case ShiftType.VIRTUAL:
            return 'Virtual';
        default:
            return 'Unknown';
    }
};

export enum DropReason {
    DROPPED = 'DROPPED',
    BLOCKED = 'BLOCKED',
    NONE = 'NONE',
    DELETED = 'DELETED',
}

export const renderDropReason = (dropReason: DropReason): string => {
    switch (dropReason) {
        case DropReason.DROPPED:
            return 'Dropped';
        case DropReason.BLOCKED:
            return 'Blocked';
        case DropReason.NONE:
            return 'None';
        case DropReason.DELETED:
            return 'Deleted';
    }
};

// Temp: conversion between graphql and zod types
export const dropReasonToZod = (dropReason: DropReason): NameAndCode => {
    return { code: renderDropReason(dropReason), name: renderDropReason(dropReason) };
};

// Given a list of shift types, return either an AND or OR filter expression of those types.
export const shiftTypesToFilters = (
    shiftTypes: ShiftType[],
    operator: FilterOperator.AND | FilterOperator.OR,
): ShiftRecurrenceFilter => {
    const filters: ShiftRecurrenceFilter[] = [];
    shiftTypes.forEach((shiftType) => {
        switch (shiftType) {
            case ShiftType.CLINIC:
                filters.push({ isClinic: { exact: true } });
                break;
            case ShiftType.VIRTUAL:
                filters.push({ isVirtual: { exact: true } });
                break;
            case ShiftType.MOBILE:
                filters.push({ isMobile: { exact: true } });
                break;
        }
    });
    let deepestFilter: ShiftRecurrenceFilter | null = null;
    let filter: ShiftRecurrenceFilter = {};
    filters.forEach((shiftFilter) => {
        if (!deepestFilter) {
            filter = shiftFilter;
            deepestFilter = shiftFilter;
        } else {
            deepestFilter[operator] = shiftFilter;
            deepestFilter = shiftFilter;
        }
    });

    return filter;
};
